type AnalyticsEvent =
  | "cta_click"
  | "phone_click"
  | "email_click"
  | "whatsapp_click"
  | "form_submit";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function trackEvent(
  event: AnalyticsEvent,
  parameters: Record<string, string> = {},
): void {
  window.dataLayer?.push({ event, ...parameters });
}
